export * from "./ToteBetsApiCalculationTarget";
//# sourceMappingURL=index.js.map